import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';

// All routes under _auth require a logged-in tenant user
export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }: { context: Record<string, unknown> }) => {
    // Auth guard handled reactively in AppShell — this is a layout route
    void context;
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
